import React, { useState, useEffect, memo } from 'react';
import 'katex/dist/katex.min.css';
import katex from 'katex';

const typewriterEffectExample = async (content, setDisplayContent) => {
    content = content.replace(/\\\[\s*/g, '\\[');  // Replace \[ with \( and remove leading spaces
    content = content.replace(/\s*\\\]/g, '\\]');  // Replace \] with \) and remove trailing spaces
    const regex = /(\\\(.*?\\\))|(\\\[[\s\S]*?\\\])|(\\begin\{array\}[\s\S]*?\\end\{array\})|(\\textit\{.*?\})|(\\textbf\{.*?\})/g;
    const parts = content.split(regex).filter(part => part !== null && part !== undefined && part !== '');
    let displayContent = '';
    for (const part of parts) {
        if (part.startsWith('\\(') || part.startsWith('\\begin') || part.startsWith('\\textit') || part.startsWith('\\textbf')) {
            // Process LaTeX content

            try {
                const isDisplayMode = part.startsWith('\\[');
                const mathContent = part.replace(/\\[\(\[\)\]]/g, '');  // Strip the delimiters
                const renderedMath = katex.renderToString(mathContent, { throwOnError: false, displayMode: isDisplayMode });

                // Simulate typing the LaTeX
                for (let i = 0; i < renderedMath.length; i++) {
                    displayContent += renderedMath[i];


                    setDisplayContent(displayContent);
/*                     await delayRandomTime(); 
 */                }
            } catch (e) {
                console.error('Error rendering LaTeX:', e);
                displayContent += `<span class="error">Failed to render LaTeX: ${part}</span>`;
                setDisplayContent(displayContent);
            }
        } else if (part.startsWith('\\[')) {
            // Process LaTeX content

            try {
                const isDisplayMode = part.startsWith('\\[');
                const mathContent = part.replace(/\\[\(\[\)\]]/g, '');  // Strip the delimiters
                const renderedMath = katex.renderToString(mathContent, { throwOnError: false, displayMode: isDisplayMode });

                // Simulate typing the LaTeX
                for (let i = 0; i < renderedMath.length; i++) {
                    displayContent += renderedMath[i];
                    setDisplayContent(displayContent);
/*                     await delayRandomTime(); 
 */                }

                const buttonsHTML = `
<button 
    onclick="handleExampleQuestion('${mathContent}')" 
    style="background-color:rgb(60, 60, 60); color: white; padding: 10px 20px; border: none; border-radius: 20px; cursor: pointer; font-size: 16px;">
    What is the equation?
</button>
`; displayContent += buttonsHTML;
                /* console.log(displayContent); */
            } catch (e) {
                console.error('Error rendering LaTeX:', e);
                displayContent += `<span class="error">Failed to render LaTeX: ${part}</span>`;
                setDisplayContent(displayContent);
            }
        } else {
            // Process plain text content
            for (let i = 0; i < part.length; i++) {
                displayContent += part[i] === '\n' ? '<br />' : part[i];
                setDisplayContent(displayContent);
                await textdelayRandomTime();
            }
        }
    }
};

const textdelayRandomTime = () => {
    return new Promise(resolve => {
        const randomDelay = Math.floor(Math.random() * 20) + 5; // Delay between 50ms to 250ms
        setTimeout(resolve, randomDelay);
    });
};

const TypewriterRendererExample = memo(({ content }) => {
    const [displayContent, setDisplayContent] = useState('');

    useEffect(() => {
        if (!content) {
            setDisplayContent('');
            return;
        }
        // Start the typewriter effect when the component loads
        typewriterEffectExample(content, setDisplayContent);
    }, [content]);

    return (
        <div>
            <div
                style={{
                    textAlign: 'left',         // Align text to the left
                    width: '45vw',
                    margin: '0 auto',          // Center the div horizontally
                    padding: '10px',           // Add padding
                    maxWidth: '900px',         // Set a max width for the container
                    marginLeft: '1vw',        // Add some space from the left
                    border: '0px solid gray',  // Gray border
                    backgroundColor: '#212936',  // Black background
                    color: 'white',            // White text color for contrast
                    fontFamily: 'Segoe UI, sans-serif',  // Font family
                    fontSize: '18px',          // Font size
                    fontWeight: 'normal',        // Bold text
                    fontStyle: 'normal',       // Italic text
                    lineHeight: '1.6',         // Line height for readability
                    letterSpacing: '1px',      // Space between letters
                    borderRadius: '10px',
                }}
                dangerouslySetInnerHTML={{ __html: displayContent }}
            />
        </div>
    );
}
);
export default TypewriterRendererExample;